
const sh = require('shelljs')
const { config } = require('../common.js')

function test(yargs) {

	sh.exec(`cd ${config.get("ops_client_path")} && jest --color`)
}

module.exports = test



// WEBPACK FOOTER //
// ./src/commands/test.js